import { createPortal } from 'react-dom'

import ErrorSnackbar from '../../../Match/ParticipationSection/components/ErrorSnackbar'

interface Props {
  isOpen: boolean
  errorMessage: string
  onClose: () => void
}

export function ErrorSnackbarPortal({ isOpen, errorMessage, onClose }: Props) {
  return createPortal(<ErrorSnackbar isOpen={isOpen} errorMessage={errorMessage} onClose={onClose} />, document.body)
}
